export const servicesContent = {
  historicalStudies: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-RE-ETUDE1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-RE-ETUDE1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/GRAHAL_ipat_re_00616Medium.jpg',
        smallAlt: 'assets/img/GRAHAL_ipat_re_00616Small.jpg'
      }
    ],
    body:
      '<h1 class="E">Études historiques</h1> <p> Les études historiques réalisées par le département Recherche et Études visent à établir un dossier exhaustif d’études et recherches documentaires retraçant l’origine, l’histoire et l’évolution d’un monument ou d’un site, d’un objet ou d’un paysage. Elles permettent d’acquérir une connaissance approfondie de l’immeuble ou du site et de son histoire, afin de réaliser une synthèse appliquée de l’existant fondée sur la recherche historique approfondie, l’apport essentiel de l’archéologie du bâti et le diagnostic patrimonial : </p> <ul> <li> Études historiques et archéologiques dans le cadre des études préalables à la restauration ou à l’entretien d’un monument historique auprès des propriétaires publics ou privés, des conservations régionales des monuments historiques, des architectes en chefs des monuments historiques et des architectes du patrimoine. </li> <li> Études historiques et documentaires et audits patrimoniaux dans le cadre d’opérations de réhabilitation ou de restructuration d’un patrimoine immobilier auprès des maîtrises d’ouvrage propriétaires ou investisseurs, des asset managers et des maîtrises d’œuvre en charge du projet, dans la perspective d’obtention d’un permis de construire soumis aux exigences du Code du patrimoine ou du Code de l’environnement. </li> <li> Etudes foncières et domaniales dans le cadre très spécifique de la recherche de propriété ou de la nécessité d’établir l’évolution de l’affectation d’un immeuble, auprès des propriétaires, des notaires ou des asset managers. </li> </ul>'
  },
  expertise: {
    images: [
      {
        mediumAlt: 'assets/img/GRAHAL_190412_GRAHAL-REPORTAGESWEB1Medium.jpg',
        smallAlt: 'assets/img/GRAHAL_190412_GRAHAL-REPORTAGESWEB1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/GRAHAL_190412_GRAHAL-REPORTAGESWEB2Medium.jpg',
        smallAlt: 'assets/img/GRAHAL_190412_GRAHAL-REPORTAGESWEB2Small.jpg'
      }
    ],
    body:
      '<h1 class="E">Expertise et assistance à maîtrise d’ouvrage</h1> <p> Dans le cadre des projets de réhabilitation ou de restructuration immobilière, le GRAHAL accompagne de son expertise les maîtrises d’ouvrage et les maîtrises d’œuvre: </p> <ul> <li> Conseil patrimonial pour l’élaboration du permis de construire en garantissant qu’il réponde aux objectifs fixés au regard de l’approche patrimoniale afin de ne pas compromettre par la suite son instruction réglementaire. </li> <li> Assistance scientifique et technique pour l’instruction du permis de construire dans un dialogue constant avec les services patrimoniaux de l’État (Architectes des bâtiments de France, Conservateurs régionaux des Monuments historiques) et les directions municipales de l’Urbanisme. </li> </ul>'
  },
  archives: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES1Smsall.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES2Smsall.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-ARCHIVES3Smsall.jpg'
      }
    ],
    body:
      "<h1 class='A'>Archives</h1><p> Grand habitué des centres d’archives à des fins de recherche historique, le GRAHAL aborde les problématiques archivistiques en prenant en compte 2 logiques complémentaires : les attentes des usagers d’un côté, les enjeux et contraintes des institutions de conservation de l’autre. </p> <p> Depuis la fin des années 1990, il propose une offre complète de prestations et intervient sur toute la chaîne archivistique, de la création des documents à leur conservation patrimoniale. </p> <h2>Stratégie archivistique, conseil et audit</h2> <p> Prestations proposées : </p> <ul> <li> Conception et mise en œuvre de politiques d’archivage, de records management et de gouvernance de l’information </li> <li>Conseil en matière archivistique</li> <li>Audits et diagnostics</li> <li> Conception et mise en œuvre d’outils et de procédures d’archivage (tableaux de gestion, chartes et référentiels d’archivage…) </li> </ul> <h2>Formation et sensibilisation</h2> <p> Les formations proposées se regroupent en 3 grandes familles : </p> <ul> <li> Fondamentaux archivistiques </li> <li>Bonnes pratiques et outils de gestion archivistique</li> <li>Conservation préventive</li> </ul> <h2>Traitement d’archives</h2> <p> Le traitement d’archives vise à résorber des situations d’arriéré ou, activé plus en amont, à éviter l’accumulation non maîtrisée de documents. </p> <p>Prestations proposées :</p> <ul> <li> Récolement </li> <li>Tri</li> <li> Classement intellectuel : cotation, rédaction d’instruments de recherche conformes aux normes en vigueur (ISAD-G…) </li> <li>Classement matériel et reconditionnement…</li> </ul> <h2>Campagnes de numérisation</h2> <p> La numérisation en tant que telle est du ressort du département Numérisation. Mais, pour se dérouler en toute sécurité, une campagne de numérisation nécessite des opérations archivistiques préalables : </p> <ul> <li> Dépoussiérage </li> <li> Cotation et pose de codes-barres </li> <li>Inventaire</li> <li>Reconditionnement approprié des documents</li> <li>Création d’outils de suivi</li> </ul> <h2> Ressources clients pour des prestations archivistiques </h2> <p> Centres d’archives : Archives nationales de France, Centre des archives diplomatiques de Nantes, Archives départementales de la Loire, Archives départementales des Yvelines…</p> <p> Administrations et institutions publiques : DDT de la Marne, DDT des Bouches-du-Rhône, DRAC du Languedoc-Roussillon, DRAC des Pays de Loire, Musée du Quai Branly, Musées de la Ville de Marseille, Museon Arlaten, Grand Lyon, SAES de Sevran…</p> <p>EPIC, entreprises et institutions privées : CEA Paris-Saclay, Centre culturel irlandais, Laboratoires Pierre Fabre…</p>"
  },
  libraries: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-BIBLIO1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-BIBLIO1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-BIBLIO2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-BIBLIO2Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-BIBLIO3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-BIBLIO3Small.jpg'
      }
    ],
    body:
      "<h1 class='B'>Bibliothèques</h1><p> Nos spécialistes en bibliothèques vous accompagnent dans l’élaboration, la gestion et la réalisation de vos projets. </p> <h6>Nos prestations</h6> <h2>Catalogage, bulletinage, indexation, exemplarisation</h2> <ul> <li> Traitements bibliographiques en vue de l’enrichissement d’un catalogue local ou d’un réseau (catalogue collectif des musées nationaux, Sudoc, catalogue collectif des bibliothèques spécialisées de la Ville de Paris…). </li> <li>Catalogage et exemplarisation au format Marc</li> <li>Audits et diagnostics</li> <li> Indexation Rameau, Dewey, cotation, encodage au format EAD. </li> </ul> <h2>Traitement matériel</h2> <ul> <li> Equipement matériel des documents : estampillage, étiquetage, pose d’antivol, pose de codes à barres, couverture... </li> </ul> <h2>Traitement de fonds et supports divers</h2> <ul> <li> Traitement des fonds récents et des fonds patrimoniaux (fonds anciens, incunables, en français ou en langues étrangères) selon les normes en vigueur qu’il s’agisse de monographies, publications en série ou littérature grise mais aussi thèses, partitions, disques et autres documents audiovisuels ou électroniques </li> <li> Elaboration de plan de classement et de système de cotation après une étude du fonds et des besoins (superficie, accessibilité, typologie) </li> <li> Inventaire sommaire, récolement </li> <li> Réalisation d’une étude sanitaire du fonds puis élaboration d’une méthodologie de traitement dans le contexte d’un délai réduit ou d’objectifs particuliers. </li> </ul> <h2>Formations</h2> <ul> <li> Formation aux fondamentaux du catalogage (ISBD, Unimarc, WinIBW) </li> <li> Formation à l’indexation (Rameau, Dewey, Blanc-Montmayeur…) </li> </ul>"
  },
  museums: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-MUSEES1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-MUSEES1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-MUSEES3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-MUSEES3Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-MUSEES4Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-MUSEES4Small.jpg'
      }
    ],
    body:
      '<h1 class="M">Musées, Museums et collections patrimoniales</h1> <p> Gestion de projet, accompagnement, formations, nos experts vous aident à mettre en place des solutions personnalisées pour tout type d’institution, de collection et d’environnement informatique : </p> <h6>Nos prestations</h6> <h2>Chantier des collections et numérisation</h2> <ul> <li> <strong> Traçabilité, Informatisation, dépoussiérage, conditionnement, marquage, stabilisation, rangement </strong> etc. Nous pouvons alors travailler avec nos partenaires qu’ils soient <strong>restaurateurs-conservateurs</strong> pour la conservation préventive ou <strong>transporteurs</strong> pour une assistance. </li> <li> <strong>Numérisation, prise de vue</strong> en partenariat avec des <strong>photographes.</strong> </li> </ul> <h2>Inventaire et récolement des collections</h2> <ul> <li> <strong>Récolement</strong> des collections en conformité avec l’arrêté du 25 mai 2004 relatif au récolement décennal. </li> <li> Assistance à la constitution d’un <strong>inventaire</strong> si ce dernier n’existe pas, si besoin en collaboration avec des <strong>experts</strong> du domaine. </li> </ul> <h2>Informatisation des collections, saisie de registres d’inventaire</h2> <ul> <li> <strong>Informatisation des collections</strong> à partir de registres existants, d’une documentation papier ou d’un récolement des collections dans nos locaux ou in situ. Selon les cas, la démarche proposée sera différente ; </li> <li> <strong>Saisie</strong> de registres d’inventaire. </li> </ul> <h2>Conseil et Formation</h2> <ul> <li> <strong>Assistance à la maîtrise d’ouvrage</strong> pour la définition de chantiers de collections ou de politiques documentaires. </li> <li> <strong>Etude et accompagnement</strong> pour la mise en œuvre d’applications métiers (photothèque, gestion et documentation des collections, mises en lignes etc.). </li> <li> <strong>Formations</strong> aux méthodes et outils (base de données, indexation et thésaurus, récolement, inventaire etc.). </li> </ul>'
  },
  documentation: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-DOC1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-DOC1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-DOC2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-DOC2Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-DOC3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-DOC3Small.jpg'
      }
    ],
    body:
      '<h1 class="D">Documentation</h1> <p> Nos ingénieurs en documentation patrimoniale vous accompagnent dans l’élaboration, la gestion et la réalisation de vos projets : </p> <h6>Nos prestations</h6> <h2>Photothèques argentiques et numériques</h2> <ul> <li> Indexation et traitement documentaire de tout type de photothèque ou d’iconothèque. </li> </ul> <h2>Recherches iconographiques et documentation patrimoniale</h2> <ul> <li> Constitution de dossiers documentaires appliqués liés au patrimoine architectural, mobilier, industriel, technique, littéraire, historique ou autre.. </li><li> Mise en place d’équipes d’iconographes spécialisés pour réaliser des recherches sur des sujets spécifiques. </li>  </ul> <h2>Base de données documentaires</h2> <ul> <li> Conseil en gestion de bases de données quels que soient les domaines. </li> <li> Assistance à la maîtrise d’ouvrage (AMO) pour un changement de base de données. </li> </ul> <h2>Conseil et Formation</h2> <ul> <li> Assistance à la reprise des données, recette, contrôle qualité. </li> <li> Rédaction de guides de saisie pour un nouvel outil ou un outil déjà en place. </li> <li> Enrichissement, harmonisation et contrôle des données. </li> <li>Indexation ou remaniement de thésaurus.</li> <li> Administration fonctionnelle. </li> </ul>'
  },
  urbanManagement: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-GU-1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-GU-1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-GU-2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-GU-2Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-GU-3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-GU-3Small.jpg'
      }
    ],
    body:
      '<h1 class="G">Gestion urbaine et paysagère du patrimoine</h1><p>i-pat® intervient aux côtés des collectivités pour l’étude et la prise en compte du patrimoine au sein de projets urbains, de documents réglementaires ou de planification. </p><ul><li>Volets patrimoniaux et éléments inscrits des Plans Locaux d’Urbanisme (PLU/PLUi). </li> <li> Sites Patrimoniaux Remarquables (SPR), Plans de Sauvegarde et de Mise en Valeur (PSMV), Plans de Valorisation de l\'Architecture et du Patrimoine (PVAP). </li> <li> Inventaires du patrimoine architectural, urbain et paysagers.</li><li>Schémas Directeurs d’Aménagement, Schémas de cohérence territoriale (SCoT). </li></ul><p>i-pat® collabore ainsi avec des sociétés de conseil en planification et urbanisme réglementaire, des agences d’architectes, d’architectes du patrimoine et d’urbanisme, des paysagistes, des sociologues, des coloristes, etc.</p>'
  },
  protection: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-LABELLISATIONMedium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-LABELLISATIONSmall.jpg'
      }
    ],
    body:
      '<h1 class="P">Protection et labellisation de patrimoines </h1> <p>i-pat® accompagne scientifiquement, méthodologiquement et stratégiquement les porteurs de projet dans la qualification de leurs patrimoines à travers des labels qui permettent leur reconnaissance régionale, nationale ou mondiale et leur inscription au sein de projets culturels et politiques : </p> <ul> <li> Patrimoine d’intérêt Régional Ile-de-France </li> <li> Architecture contemporaine remarquable </li> <li> Inscription et classement d’immeubles Monuments historiques </li> <li> Villes et Pays d’Art et d’Histoire </li> <li> Jardin remarquable </li> <li> Patrimoine Européen et Itinéraire culturel Européen </li> <li> Registre Mémoire du Monde de l’UNESCO </li> </ul>'
  },
  worldHeritage: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-PATRIMOINE1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-PATRIMOINE1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-PATRIMOINE2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-PATRIMOINE2Small.jpg'
      }
    ],
    body:
      '<h1 class="P">Patrimoine mondial </h1> <p>i-pat® est une référence dans le domaine du Patrimoine mondial de l’UNESCO.</p><p> Expert auprès du Centre du Patrimoine mondial de l’UNESCO depuis 2009, i-pat® accompagne les porteurs de projets dans leurs études de faisabilité, vers l’inscription sur la Liste indicative française, dans la réalisation de leurs dossiers de candidature d’inscription sur la Liste du Patrimoine mondial et dans la définition des plans de gestion de sites déjà inscrits ou en cours d’inscription.</p><p> i-pat® assiste également les porteurs de projet pour leur présentation devant les différentes instances au cours de cette procédure d’inscription (Comité national des Biens français du patrimoine mondial, ICOMOS France et International, Sessions du Comité du Patrimoine mondial). </p>'
  },

  museumProjects: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-museo-1Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-museo-1Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-museo-2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-museo-2Small.jpg'
      },
      {
        mediumAlt: 'assets/img/PRESTA-IPAT-museo-3Medium.jpg',
        smallAlt: 'assets/img/PRESTA-IPAT-museo-3Small.jpg'
      }
    ],
    body:
      '<h1 class="P">Projets muséologiques, culturels et patrimoniaux </h1> <p> i-pat® accompagne particuliers, entreprises, institutions et collectivités dans leurs projets de valorisation de leurs patrimoines : </p> <ul> <li> définition de contenus </li> <li> conception muséologique </li> <li> réalisation de Schémas d’interprétation </li> <li> création de visites guidées et formation des guides médiateurs </li> <li> réalisation de supports de médiation. </li> </ul>'
  },

  formationName: {
    images: [
      {
        mediumAlt: 'assets/img/PRESTA-I-DOC-MUSEES2Medium.jpg',
        smallAlt: 'assets/img/PRESTA-I-DOC-MUSEES2Small.jpg'
      }
    ],
    body: `
    <p>
    Plus que jamais au service des professionnels du Patrimoine, GRAHAL met à leur
    disposition ses 30 ans de savoir-faire et d'expérience de terrain pour les
    aider à répondre à leurs problématiques quotidiennes.
  </p>
  <p>
    <strong>
      Nous vous proposons des formations sur mesure adaptées à vos besoins, à vos
      spécificités et surtout à vos objectifs.
    </strong>
  </p>
  <p>
    <strong>
      Que vous soyez une collectivité, un particulier, une société privée ou une
      institution, nos consultants sont à votre écoute. Vos idées deviendront nos
      projets !
    </strong>
  </p>
  <p>
    <a href="mailto:grahal.academie@grahal.fr" class="button">Contactez-nous !</a>
  </p>
  <h3>Quelques-unes de nos formations</h3>
  <h4>Connaissance du patrimoine</h4>
  <ul>
    <li>
      Initiation à l’histoire du patrimoine / initiation à la notion de patrimoine
    </li>
    <li>Méthodologie de la connaissance du patrimoine</li>
    <li>
      Méthodologie d’analyse patrimoniale : définir et s’approprier des enjeux
      patrimoniaux
    </li>
    <li>Initiation à l’archéologie du bâti</li>
  </ul>
  <h4>Développement des territoires</h4>
  <ul>
    <li>
      Compréhension, gestion et utilisation de dispositifs, labels patrimoniaux et
      documents réglementaires
    </li>
    <li>
      Prise en compte du patrimoine au sein des stratégies de développement
      territorial : enjeux et opportunités
    </li>
    <li>Se former aux notions et aux enjeux du Patrimoine mondial</li>
  </ul>
  <h4>
    Gestion des collections
  </h4>
  <ul>
    <li>Inventaire, récolement et informatisation des collections</li>
    <li>Chantiers des collections</li>
    <li>
      Formation aux bases de données de gestion informatisées des collections
      (saisie, administration fonctionnelle, harmonisation des données)
    </li>
    <li>Mise en valeur des collections par la photographie</li>
  </ul>
  <h4>Documentation</h4>
  <ul>
    <li>Principes de l’indexation</li>
    <li>Ecrits professionnels : source d’information</li>
    <li>Harmonisation et reprise de données</li>
    <li>Saisie documentaire et administrative</li>
    <li>Gestion des fonds iconographiques</li>
  </ul>
  <h4>Bibliothèques</h4>
  <ul>
    <li>Fondamentaux du catalogage</li>
    <li>Catalogage dans le SUDOC</li>
    <li>Catalogage de documents audiovisuels et/ou électroniques</li>
    <li>Catalogage de documents atypiques (cartes, partitions, objets…)</li>
    <li>Indexation Rameau</li>
    <li>Conservation préventive</li>
  </ul>
  <h4>Archives</h4>
  <ul>
    <li>
      Parcours fondamentaux
      <ul class="narrow mtmd">
        <li>Principes fondateurs et notions de base archivistiques</li>
        <li>Gestion quotidienne des archives</li>
        <li>
          Gestion des archives patrimoniales (collecte, classement et conservation
          préventive)
        </li>
        <li>
          Identifier les typologies documentaires : formation à la diplomatique
        </li>
        <li>Préparer et gérer un chantier de numérisation d’archives</li>
      </ul>
    </li>
    <li>
      Modules complémentaires
      <ul class="narrow mtmd">
        <li>Rédiger et utiliser un plan de classement</li>
        <li>Rédiger et utiliser un instrument de recherche archivistique</li>
        <li>Initiation au droit des archives</li>
        <li>Formation à l’encodage EAD</li>
      </ul>
    </li>
  </ul>
  <p>GRAHAL ACADEMIE est agréée par la DIRRECTE sous le n° 11755965575</p>
      `
  }
}
